import { render, staticRenderFns } from "./RouterWanInfo.vue?vue&type=template&id=8bdaac24"
import script from "./RouterWanInfo.vue?vue&type=script&lang=js"
export * from "./RouterWanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports